// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"940f2fc0","511":"14fb99fc"}[chunkId] + ".chunk.js";
};